import React from "react";
import {stateSwitch} from "@common-hooks/state-switch"
import {CardForm} from './components/card-form'

export const PaySection = ({block, nextRout, nextPageId, openModalHandler}) => {

    const tariffPrice = localStorage.getItem('tariffPrice')


    return (
        <div className={block('pay-wrapper')}>

                <CardForm {...{block, nextRout, nextPageId, openModalHandler}} />

            </div>
    )
}

